import { Alert, Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type { VariablesAccess } from 'modules/documents/lib/getVariablesAccess'

interface Props {
  access: VariablesAccess
}

const backgroundColor = (access: VariablesAccess) => {
  return access == 'no_access' ? 'error' : 'warning'
}

const message = (access: VariablesAccess) => {
  return access == 'no_access'
    ? i18n.t('split_documents.templates.create_modal.no_access')
    : i18n.t('split_documents.templates.create_modal.partial_access')
}
const TemplateAccessWarning = ({ access }: Props) => {
  return (
    <Alert color={backgroundColor(access)}>
      <Box gap="s6" flexDirection="row">
        <Box>
          <Icon.Medium icon="info-circle-line" color="grey800" />
        </Box>
        <Text.Normal>{message(access)}</Text.Normal>
      </Box>
    </Alert>
  )
}

export default TemplateAccessWarning
